const CustomThemePalette = {
	blue: {
		light: {
			primary: {
				main: '#1976d2',
				lightMain: '#1976d2',
			},
			border: {
				main: '#e4e4e4'
			}
		},
		dark: {
			primary: {
				main: '#ffffff',
				contrastText: '#1976d2',
				lightMain: '#1976d2',
			},
			background: {
				default: '#0b192a',
			},
			border: {
				main: '#283545'
			}
		}
	},
	red: {
		light: {
			primary: {
				main: '#c62828',
				lightMain: '#c62828',
			},
			border: {
				main: '#e4e4e4'
			}
		},
		dark: {
			primary: {
				main: '#ffffff',
				contrastText: '#c62828',
				lightMain: '#c62828',
			},
			background: {
				default: '#3f0000',
			},
			border: {
				main: '#571f20'
			}
		}
	},
	deepPurple: {
		light: {
			primary: {
				main: '#512da8',
				lightMain: '#512da8',
			},
			border: {
				main: '#e4e4e4'
			}
		},
		dark: {
			primary: {
				main: '#ffffff',
				contrastText: '#512da8',
				lightMain: '#512da8',
			},
			background: {
				default: '#19082f',
			},
			border: {
				main: '#352649'
			}
		}
	},
	cyan: {
		light: {
			primary: {
				main: '#00838f',
				lightMain: '#00838f',
			},
			border: {
				main: '#e4e4e4'
			}
		},
		dark: {
			primary: {
				main: '#ffffff',
				contrastText: '#00838f',
				lightMain: '#00838f',
			},
			background: {
				default: '#00363a',
			},
			border: {
				main: '#254f52'
			}
		}
	},
	grey: {
		light: {
			primary: {
				main: '#616161',
				lightMain: '#616161',
			},
			border: {
				main: '#e4e4e4'
			}
		},
		dark: {
			primary: {
				main: '#ffffff',
				contrastText: '#616161',
				lightMain: '#616161',
			},
			background: {
				default: '#212121',
			},
			border: {
				main: '#3c3c3c'
			}
		}
	},
	black: {
		light: {
			primary: {
				main: '#000000',
				lightMain: '#AAAAAA',
			},
			border: {
				main: '#e4e4e4'
			}
		},
		dark: {
			primary: {
				main: '#ffffff',
				contrastText: '#000000',
				lightMain: '#AAAAAA',
			},
			background: {
				default: '#000000',
			},
			border: {
				main: '#1f1f1f'
			}
		}
	},
};

export default CustomThemePalette;